import { render } from "./ShowContentModel.vue?vue&type=template&id=05db95ee&ts=true"
import script from "./ShowContentModel.vue?vue&type=script&lang=ts"
export * from "./ShowContentModel.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__